// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { registerMicroApps, start } from 'qiankun';

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import VXETable from 'vxe-table-quantdata'
import zhCN from 'vxe-table-quantdata/lib/locale/lang/zh-CN'
import enUS from 'vxe-table-quantdata/lib/locale/lang/en-US'
import FilterArea from './common/components/FilterArea'

import 'ant-design-vue/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css'
import {Form, TreeSelect, DatePicker, Carousel, Icon, Button, Tabs, Dropdown, Menu, Tooltip, Select, Divider} from 'ant-design-vue'
Vue.config.productionTip = false
Vue.use(Form)
Vue.use(TreeSelect)
Vue.use(DatePicker)
Vue.use(Carousel)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Divider)
Vue.component('FilterArea', FilterArea)

VXETable.setup({
  translate (key, args) {
    // 例如，只翻译 "i18n." 开头的键值
    if (key && key.startsWith('i18n.')) {
      return i18n.t(key.substr(5), args)
    }else{
      return key
    }

  }
})

Vue.use(VXETable)

registerMicroApps([
  {
    name: 'esgreport',
    entry: '/esg-report',
    container: '#ESGReport',
    activeRule: '/esgreport',
  },

]);

// 启动 qiankun
start();

/*  添加全局自定义指令 */
Vue.directive('divloading', {
  inserted(el,binding) {
    el.style.position = "relative"
    var loading_box = document.createElement("div")
    if(binding.value) loading_box.className = "vxe-loading is--visible"
    else loading_box.className = "vxe-loading"
    var loading_panel = document.createElement("div")
    loading_panel.className = "vxe-loading--spinner"
    loading_box.appendChild(loading_panel)
    el.appendChild(loading_box)
  },
  update(el,binding,vnode) {
    var key = binding.value
    var class_name = new RegExp("vxe-loading")
    for(var i in el.childNodes){
      let is_loading = class_name.test(el.childNodes[i].className)
      if(!key&&is_loading) {
        el.childNodes[i].className = "vxe-loading"
      } else if(key&&is_loading) {
        el.childNodes[i].className = "vxe-loading is--visible"
      }
    }
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',

})





// WEBPACK FOOTER //
// ./src/main.js